var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForecast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 35.2123C27.9411 35.2123 36 27.3297 36 17.6061C36 7.88253 27.9411 0 18 0C8.05887 0 0 7.88253 0 17.6061C0 27.3297 8.05887 35.2123 18 35.2123Z",
    fill: "url(#paint0_linear_668_108482)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8945 16.7554H27.8723V25.9998H22.8945V16.7554Z",
    fill: "url(#paint1_linear_668_108482)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.918 26H12.9402V18.1778H17.918V26Z",
    fill: "url(#paint2_linear_668_108482)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8945 26H17.9168V21.0222H22.8945V26Z",
    fill: "url(#paint3_linear_668_108482)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96094 22.4443H12.9387V25.9999H7.96094V22.4443Z",
    fill: "url(#paint4_linear_668_108482)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1253 10.6071L26.8071 11.9253L20.6587 18.0738C20.5919 18.1404 20.5014 18.1778 20.4071 18.1778C20.3128 18.1778 20.2223 18.1404 20.1555 18.0738L15.4293 13.3471L7.5031 21.2738L7 20.7707L15.1778 12.5929C15.2446 12.5263 15.335 12.4889 15.4293 12.4889C15.5236 12.4889 15.6141 12.5263 15.6809 12.5929L20.4071 17.3196L26.304 11.4222L27.6222 10.104L28.1253 10.6071Z",
    fill: "url(#paint5_linear_668_108482)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8078 11.9253V11.4222H26.3047L27.6229 10.104L28.126 10.6071L26.8078 11.9253Z",
    fill: "#6C2AD2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2312 12.8444H27.5201V10.7111H25.3867V10H27.8756C27.9699 10 28.0603 10.0375 28.127 10.1041C28.1937 10.1708 28.2312 10.2613 28.2312 10.3556V12.8444Z",
    fill: "#6D3CD7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_108482",
    x1: 18,
    y1: 35.2123,
    x2: 18,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_668_108482",
    x1: 25.3834,
    y1: 16.7554,
    x2: 25.3834,
    y2: 25.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D3CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75BBF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_668_108482",
    x1: 15.4291,
    y1: 26,
    x2: 15.4291,
    y2: 18.1778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74B7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3FD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_668_108482",
    x1: 20.4056,
    y1: 26,
    x2: 20.4056,
    y2: 21.0222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75B6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E3FD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_668_108482",
    x1: 10.4498,
    y1: 22.4443,
    x2: 10.4498,
    y2: 25.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D3FD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75B6F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_668_108482",
    x1: 17.5627,
    y1: 10.104,
    x2: 17.5627,
    y2: 21.2738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D3CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75BBF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecast);
export default __webpack_public_path__ + "static/media/forecast.ac42ed513175d7177749e86195ef6262.svg";
export { ForwardRef as ReactComponent };